import {
  DashboardUserEventsStatisticsState,
  REQUEST_DASHBOARD_USER_EVENTS_STATISTICS,
  REQUEST_DASHBOARD_USER_EVENTS_STATISTICS_DONE
} from "./types";

const initialState: DashboardUserEventsStatisticsState = {
  isLoading: true,
  userEvents: []
};

export function reducer(state = initialState, action: any) {
  switch (action.type) {
    case REQUEST_DASHBOARD_USER_EVENTS_STATISTICS:
      return {
        isLoading: true,
        userEvents: action.payload
      };
    case REQUEST_DASHBOARD_USER_EVENTS_STATISTICS_DONE:
      return {
        isLoading: false,
        userEvents: action.payload
      };
    default:
      return state;
  }
}
